import { DefinedDefaults } from "@/ui/lib";
import { cn } from "@/ui/lib/utils";
import { HTMLAttributes, InputHTMLAttributes } from "react";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const CHECKBOX_ORIENTATION_CLASS_MAP = {
  default: "grid-cols-[theme(spacing.4)_1fr]",
  reverse: "grid-cols-[1fr_theme(spacing.4)] [&>div:first-child]:col-start-2 [&>span]:col-start-1 [&>div:last-child]:col-start-1",
} as const;

export const CHECKBOX_VARIANT_CLASS_MAP = {
  default: "",
  boxed: cn(
    "bg-white",
    "p-4 transition-colors ease-in-out duration-200 rounded-sys-sm border border-solid",
    "border-component-checkbox-variant-boxed-unchecked has-[:checked]:border-component-checkbox-variant-boxed-checked",
  ),
} as const;

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TCheckboxOrientation = keyof typeof CHECKBOX_ORIENTATION_CLASS_MAP;
export type TCheckboxVariant = keyof typeof CHECKBOX_VARIANT_CLASS_MAP;

export type TCheckboxProps = {
  label: string;
  description?: string;
  orientation?: TCheckboxOrientation;
  variant?: TCheckboxVariant;
  input?: Pick<
    InputHTMLAttributes<HTMLInputElement>,
    "checked" | "defaultChecked" | "disabled" | "name" | "onChange" | "value"
  >;
} & HTMLAttributes<HTMLElement>;

type TCheckboxDefaultProps = DefinedDefaults<
  TCheckboxProps,
  "orientation" | "variant"
>;


/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const CHECKBOX_DEFAULTS = {
  orientation: "default",
  variant: "default",
} satisfies TCheckboxDefaultProps;
